import React, { useState } from "react";
import { CalendarPlus, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { useT } from "../../lib/i18n";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter,
} from "../ui/dialog";

export const PlanViewingDialog = ({ listingId, user, navigate }) => {
  const { t } = useT();
  const [open, setOpen] = useState(false);
  const [vw, setVw] = useState({ scheduled_at: "", agent_name: "", notes: "" });
  const [busy, setBusy] = useState(false);

  const save = async () => {
    if (!vw.scheduled_at) {
      toast.error(t("p2.view.errDate"));
      return;
    }
    setBusy(true);
    try {
      await api("/viewings", {
        method: "POST",
        body: JSON.stringify({
          listing_id: listingId,
          scheduled_at: new Date(vw.scheduled_at).toISOString(),
          agent_name: vw.agent_name || null,
          notes: vw.notes || null,
        }),
      });
      setOpen(false);
      setVw({ scheduled_at: "", agent_name: "", notes: "" });
      toast.success(t("p2.view.planned"));
    } catch (e) {
      toast.error(e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button
          variant="outline"
          className="mt-4 w-full rounded-2xl"
          data-testid="detail-plan-viewing"
          onClick={(e) => {
            if (!user) {
              e.preventDefault();
              navigate("/login");
            }
          }}
        >
          <CalendarPlus size={16} className="mr-2" /> {t("p2.view.plan")}
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="font-display">{t("p2.view.plan")}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label>{t("p2.view.datetime")}</Label>
            <Input
              type="datetime-local"
              className="mt-2 rounded-xl"
              data-testid="viewing-datetime"
              value={vw.scheduled_at}
              onChange={(e) => setVw({ ...vw, scheduled_at: e.target.value })}
            />
          </div>
          <div>
            <Label>{t("p2.view.agent")} ({t("common.optional")})</Label>
            <Input className="mt-2 rounded-xl" value={vw.agent_name} onChange={(e) => setVw({ ...vw, agent_name: e.target.value })} />
          </div>
          <div>
            <Label>{t("p2.view.notes")} ({t("common.optional")})</Label>
            <Textarea className="mt-2 rounded-xl" value={vw.notes} onChange={(e) => setVw({ ...vw, notes: e.target.value })} />
          </div>
        </div>
        <DialogFooter>
          <Button onClick={save} disabled={busy} data-testid="viewing-save" className="rounded-xl bg-brandblue hover:bg-brandblue/90">
            {busy ? <Loader2 className="animate-spin" size={18} /> : t("p2.view.planBtn")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
